import { Http } from '../../../support';

const initialState = {
  busy: false,
  result: undefined,
  error: undefined,
};

const cancel = async (store, uuids, uuid) => {
  store.setState((state) => {
    state.app.retenciones.cancel.busy = true;
  });

  try {
    const body = {
      action: 'cancel',
      uuids,
    };

    let response;

    if (uuid) {
      response = await Http.patch(`api/retenciones/${uuid}`, body);
    } else {
      response = await Http.patch(`api/retenciones`, body);
    }

    store.setState((state) => {
      state.app.retenciones.cancel.busy = false;
      state.app.retenciones.cancel.result = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.retenciones.cancel.busy = false;
      state.app.retenciones.cancel.error = error.data || error;
    });
  }
};

const resetError = (store) => (state) => {
  state.app.retenciones.cancel.error = undefined;
};

const resetResult = (store) => (state) => {
  state.app.retenciones.cancel.busy = false;
  state.app.retenciones.cancel.result = undefined;
};

const reset = (store) => (state) => {
  state.app.retenciones.cancel = {
    ...initialState,
  };
};

const actions = {
  cancel,
  reset,
  resetError,
  resetResult,
};

const RetencionesCancelStore = {
  state: () => initialState,
  actions,
};

export default RetencionesCancelStore;
